exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topDiv {\n  padding-top: 59px;\n  background: whitesmoke;\n  height: 100vh; }\n\n#toast {\n  visibility: hidden;\n  max-width: 300px;\n  height: 50px;\n  /*margin-left: -125px;*/\n  margin: auto;\n  background-color: #333;\n  color: #fff;\n  text-align: center;\n  border-radius: 2px;\n  position: fixed;\n  z-index: 1;\n  left: 60%;\n  right: 0;\n  bottom: 80%;\n  font-size: 13px;\n  white-space: nowrap; }\n\n#toast #img {\n  width: 50px;\n  height: 50px;\n  float: left;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  box-sizing: border-box;\n  background-color: #111;\n  color: #fff; }\n\n#toast #desc {\n  color: #fff;\n  padding: 16px;\n  overflow: hidden;\n  white-space: nowrap; }\n\n#toast.show {\n  visibility: visible;\n  animation: fadein 0.5s, expand 0.5s 0.5s,stay 3s 1s, shrink 0.5s 4s, fadeout 0.5s 4.5s; }\n\ndiv[title=\"Stop drawing\"] {\n  height: 28px;\n  width: 28px;\n  cursor: pointer; }\n\ndiv[title=\"Draw a circle\"] {\n  height: 28px;\n  width: 28px;\n  cursor: pointer; }\n\ndiv[title=\"Draw a rectangle\"] {\n  height: 28px;\n  width: 28px;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/geofence-add/geofence-add.component.scss
// module id = ../../../../../src/app/geofence-add/geofence-add.component.scss
// module chunks = main